
<div class="bradcam_area bradcam_bg_2" id="goToTop">
    <div class="container">
        <div class="row">
            <div class="col-xl-12">
                <div class="bradcam_text">
                    <h3>FAQ</h3>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="works_area d-none d-sm-block">
    <div class="container">
        <div class="row" >
            <div class="col-lg-12">
                <div class="section_title text-center mb-90">
                    <span class="wow lightSpeedIn" data-wow-duration="1s" data-wow-delay=".1s"></span>
                    <h3 class="wow fadeInUp" data-wow-duration="1s" data-wow-delay=".2s" i18n>How it Works</h3>
                    <p class="wow fadeInUp" data-wow-duration="1s" data-wow-delay=".3s" i18n>We provide online instant cash loans with quick approval that suit your term</p>
                </div>
            </div>
        </div>
        <div class="row" id="HowItWorks">
            <div class="col-md-6 col-lg-4" data-aos="fade-up" data-aos-offset="500" data-aos-duration="500">
                <div class="single_works wow fadeInUp" data-wow-duration="1s" data-wow-delay=".4s">
                    <span>
                        01
                    </span>
                    <h3 i18n>Make your transaction</h3>
                    <p i18n>Enter The Amount In The Receiver’s Or Beneficiary’s Currency.
                        Enter The Sender And Receiver’s Information.
                        Choose A Method Of Delivery.
                        Submit The Form.
                    </p>
                </div>
            </div>
            <div class="col-md-6 col-lg-4" data-aos="fade-up" data-aos-offset="500" data-aos-duration="1000">
                <div class="single_works wow fadeInUp" data-wow-duration="1s" data-wow-delay=".5s">
                    <span>
                        02
                    </span>
                    <h3 i18n>Pay the amount to send</h3>
                    <p i18n>Via Interac E-Transfer.
                        We're Integrated With All Canadian Banks For Free Interac E-Transfer.</p>
                </div>
            </div>
            <div class="col-md-6 col-lg-4" data-aos="fade-up" data-aos-offset="500" data-aos-duration="1500">
                <div class="single_works wow fadeInUp" data-wow-duration="1s" data-wow-delay=".6s">
                    <span>
                        03
                    </span>
                    <h3 i18n>Receive the money</h3>
                    <p i18n>Track Your Transaction Using The Code Provided.
                        Both You And Your Recipient Can Be Notified Of Funds Transfer.</p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="works_area d-block d-sm-none">
    <div class="container">
        <div class="row" >
            <div class="col-lg-12">
                <div class="section_title text-center mb-90">
                    <span class="wow lightSpeedIn" data-wow-duration="1s" data-wow-delay=".1s"></span>
                    <h3 class="wow fadeInUp" data-wow-duration="1s" data-wow-delay=".2s" i18n>How it Works</h3>
                    <p class="wow fadeInUp" data-wow-duration="1s" data-wow-delay=".3s" i18n>We provide online instant cash loans with quick approval that suit your term</p>
                </div>
            </div>
        </div>
        <div class="row" id="HowItWorksXs">
            <div class="col-md-6 col-lg-4">
                <div class="single_works wow fadeInUp" data-wow-duration="1s" data-wow-delay=".4s">
                    <span>
                        01
                    </span>
                    <h3 i18n>Make your transaction</h3>
                    <p i18n>Enter The Amount In The Receiver’s Or Beneficiary’s Currency.
                        Enter The Sender And Receiver’s Information.
                        Choose A Method Of Delivery.
                        Submit The Form.
                    </p>
                </div>
            </div>
            <div class="col-md-6 col-lg-4">
                <div class="single_works wow fadeInUp" data-wow-duration="1s" data-wow-delay=".5s">
                    <span>
                        02
                    </span>
                    <h3 i18n>Pay the amount to send</h3>
                    <p i18n>Via Interac E-Transfer.
                        We're Integrated With All Canadian Banks For Free Interac E-Transfer.</p>
                </div>
            </div>
            <div class="col-md-6 col-lg-4">
                <div class="single_works wow fadeInUp" data-wow-duration="1s" data-wow-delay=".6s">
                    <span>
                        03
                    </span>
                    <h3 i18n>Receive the money</h3>
                    <p i18n>Track Your Transaction Using The Code Provided.
                        Both You And Your Recipient Can Be Notified Of Funds Transfer.</p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="accordion_area">
    <div class="container">
        <div class="row justify-content-end">
            <div class="col-lg-6">
                <div class="faq_ask pl-68">
                    <h3 class="wow fadeInRight" data-wow-duration="1s" data-wow-delay=".3s" i18n>Frequently ask</h3>
                    <div id="accordion">
                        <div class="card wow fadeInUp" data-wow-duration="1.1s" data-wow-delay=".3s">
                            <div class="card-header" id="headingOnee">
                              <h5 class="mb-0">
                                <button class="btn btn-link" data-toggle="collapse" data-target="#collapseOnee" aria-expanded="true" aria-controls="collapseOnee" i18n>
                                    What are acceptable ID documents for picking up money?
                                </button>
                              </h5>
                            </div>
                        
                            <div id="collapseOnee" class="collapse show" aria-labelledby="headingOnee" data-parent="#accordion">
                              <div class="card-body" i18n>
                                In general passports and national IDs are acceptable.
                              </div>
                            </div>
                          </div>
                            <div class="card wow fadeInUp" data-wow-duration="1.2s" data-wow-delay=".4s">
                                <div class="card-header" id="headingOne">
                                    <h5 class="mb-0">
                                        <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne" i18n>
                                            How do I find out if my money has been sent?
                                        </button>
                                    </h5>
                                </div>
                                <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordion" style="">
                                    <div class="card-body" i18n>Any time after sending, you will receive a link that allows you to check the status of your transaction.
                                    </div>
                                </div>
                            </div>
                            <div class="card wow fadeInUp" data-wow-duration="1.3s" data-wow-delay=".5s">
                                <div class="card-header" id="headingThree">
                                    <h5 class="mb-0">
                                        <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree" i18n>
                                            What rate do you use?
                                        </button>
                                    </h5>
                                </div>
                                <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion" style="">
                                    <div class="card-body" i18n>We use the midmarket rates
                                    </div>
                                </div>
                            </div>
                            <div class="card wow fadeInUp" data-wow-duration="1.4s" data-wow-delay=".6s">
                                <div class="card-header" id="headingThree4">
                                    <h5 class="mb-0">
                                        <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseThree4" aria-expanded="false" aria-controls="collapseThree4" i18n>
                                            Is there any hidden fees?
                                        </button>
                                    </h5>
                                </div>
                                <div id="collapseThree4" class="collapse" aria-labelledby="headingThree4" data-parent="#accordion" style="">
                                    <div class="card-body" i18n>No, we're here to help the community and we do not plan to charge our customers.
                                    </div>
                                </div>
                            </div>
                            <div class="card wow fadeInUp" data-wow-duration="1.4s" data-wow-delay=".6s">
                                <div class="card-header" id="headingThree4">
                                    <h5 class="mb-0">
                                        <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseThree4" aria-expanded="false" aria-controls="collapseThree4" i18n>
                                            Which banks do you cover?
                                        </button>
                                    </h5>
                                </div>
                                <div id="collapseThree4" class="collapse" aria-labelledby="headingThree4" data-parent="#accordion" style="">
                                    <div class="card-body" i18n>We deposit money at all the major Cameroon banks.
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- testimonial_area  -->
<div class="testimonial_area  ">
    <div class="container">
        <div class="row">
            <div class="col-xl-12">
                <div class="testmonial_active owl-carousel">
                    <div class="single_carousel">
                        <div class="row">
                            <div class="col-lg-11">
                                <div class="single_testmonial d-flex align-items-center">
                                    <div class="thumb">
                                        <img src="./../../../assets/img/testmonial/author.png" alt="">
                                        <div class="quote_icon">
                                            <i class="Flaticon flaticon-quote"></i>
                                        </div>
                                    </div>
                                    <div class="info">
                                        <p i18n>"Working in conjunction with humanitarian aid agencies, we have supported programmes to help alleviate human suffering through animal welfare when people might depend on livestock as their only source of income or food.</p>
                                        <span>- Micky Mouse</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="single_carousel">
                        <div class="row">
                            <div class="col-lg-11">
                                <div class="single_testmonial d-flex align-items-center">
                                    <div class="thumb">
                                        <img src="./../../../assets/img/testmonial/author.png" alt="">
                                        <div class="quote_icon">
                                            <i class=" Flaticon flaticon-quote"></i>
                                        </div>
                                    </div>
                                    <div class="info">
                                        <p i18n>"Working in conjunction with humanitarian aid agencies, we have supported programmes to help alleviate human suffering through animal welfare when people might depend on livestock as their only source of income or food.</p>
                                        <span>- Micky Mouse</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="single_carousel">
                        <div class="row">
                            <div class="col-lg-11">
                                <div class="single_testmonial d-flex align-items-center">
                                    <div class="thumb">
                                        <img src="./../../../assets/img/testmonial/author.png" alt="">
                                        <div class="quote_icon">
                                            <i class="Flaticon flaticon-quote"></i>
                                        </div>
                                    </div>
                                    <div class="info">
                                        <p i18n>"Working in conjunction with humanitarian aid agencies, we have supported programmes to help alleviate human suffering through animal welfare when people might depend on livestock as their only source of income or food.</p>
                                        <span>- Micky Mouse</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- /testimonial_area  -->

<div class="brad_area">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="brad_active owl-carousel">
                    <div class="single_brand wow fadeInUp" data-wow-duration="1s" data-wow-delay=".2s">
                        <img src="./../../../assets/img/brand/1.png" alt="">
                    </div>
                    <div class="single_brand wow fadeInUp" data-wow-duration="1s" data-wow-delay=".3s">
                        <img src="./../../../assets/img/brand/2.png" alt="">
                    </div>
                    <div class="single_brand wow fadeInUp" data-wow-duration="1s" data-wow-delay=".4s">
                        <img src="./../../../assets/img/brand/3.png" alt="">
                    </div>
                    <div class="single_brand wow fadeInUp" data-wow-duration="1s" data-wow-delay=".5s">
                        <img src="./../../../assets/img/brand/4.png" alt="">
                    </div>
                    <div class="single_brand wow fadeInUp" data-wow-duration="1s" data-wow-delay=".6s">
                        <img src="./../../../assets/img/brand/5.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="apply_loan overlay">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-8 col-md-7">
                <div class="loan_text wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".3s">
                    <h3 i18n>Create your account and, 
                        make a transaction</h3>
                </div>
            </div>
            <div class="col-lg-4 col-md-5">
                <div class="loan_btn wow fadeInUp" data-wow-duration="1.2s" data-wow-delay=".4s">
                    <a class="boxed-btn3 submitZoom" i18n>Create</a>
                </div>
            </div>
        </div>
    </div>
</div>




